<div
    class="container"
    *ngIf="loaded"
>
    <mat-tab-group
        #matGroup
        [selectedIndex]="index"
    >
        <mat-tab label="Tickets">
            <app-filter-bar filterComponentName="tickets"></app-filter-bar>
            <app-tiket></app-tiket>
        </mat-tab>
    </mat-tab-group>
</div>
